import { useMemo } from 'react'

import { useGetEspPartnerQuery } from '../../api/espApi'
import { getSponsorshipStatus } from '../../lib/getSponsorshipStatus'
import { IEspRequest, IEspSponsorship, TEspSponsorshipStatus } from '../types'

const EMPTY_REQUESTS: IEspRequest[] = []

interface IEspSponsorshipStatusResult {
  status: TEspSponsorshipStatus
  sponsorship: IEspSponsorship | null
  requests: IEspRequest[]
  hasPendingChange: boolean
  isLoading: boolean
}

/** Partner-scoped requests + sponsorship with the derived status, for the UI. */
export const useEspSponsorshipStatus = (partnerId: string): IEspSponsorshipStatusResult => {
  const { data, isLoading } = useGetEspPartnerQuery({ partnerId }, { skip: !partnerId })

  const requests = data?.requests ?? EMPTY_REQUESTS
  const sponsorship = data?.sponsorship ?? null

  const status = useMemo(
    () => getSponsorshipStatus(partnerId, requests, sponsorship ? [sponsorship] : []),
    [partnerId, requests, sponsorship]
  )

  const hasPendingChange = useMemo(
    () => requests.some((request) => request.type === 'change' && request.status === 'pending'),
    [requests]
  )

  return {
    status,
    sponsorship,
    requests,
    hasPendingChange,
    isLoading,
  }
}
